import { useTranslation } from 'react-i18next';

export const useAppTranslation = () => {
  const { t, i18n } = useTranslation();

  // Helper functions for common formatting
  const formatCurrency = (amount: number) => {
    return t('currency.format', { amount: amount.toFixed(2) });
  };

  const formatDate = (dateString: string, includeTime = false) => {
    const date = new Date(dateString);
    const locale = i18n.language === 'ro' ? 'ro-RO' : 
                   i18n.language === 'ru' ? 'ru-RU' : 'en-US';
    
    if (includeTime) {
      return date.toLocaleString(locale);
    }
    return date.toLocaleDateString(locale);
  };

  const getTransactionTypeDisplay = (type: string) => {
    switch (type) {
      case 'SALE': return t('transaction.sale');
      case 'STOCK_ADDITION':
      case 'STOCK_IN': return t('transaction.stockIn');
      case 'STOCK_REMOVAL':
      case 'STOCK_OUT': return t('transaction.stockOut');
      case 'STOCK_ADJUSTMENT':
      case 'INVENTORY_ACTUALIZATION': return t('transaction.inventoryActualization');
      case 'RETURN': return t('transaction.return');
      default: return type;
    }
  };

  const getRoleDisplay = (role: string) => {
    switch (role) {
      case 'ROLE_ADMIN': return t('user.admin');
      case 'ROLE_WAREHOUSE': return t('user.warehouse');
      case 'ROLE_INVENTORY': return t('user.inventoryOperator');
      case 'ROLE_TRANSPORT': return t('user.transportManager');
      case 'ROLE_VIEWER': return t('user.viewer');
      case 'ROLE_EMPLOYEE': return t('user.employee');
      default: return role;
    }
  };

  return {
    t,
    i18n,
    formatCurrency,
    formatDate,
    getTransactionTypeDisplay,
    getRoleDisplay
  };
};

export default useAppTranslation;
